var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _path2, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 64,
    viewBox: "0 0 90 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 64,
    rx: 2,
    fill: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H88C89.1046 0 90 0.895431 90 2V7H0V2Z",
    fill: "#1E2224"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 9.5,
    width: 20,
    height: 52,
    fill: "#D9D9D9",
    stroke: "#DCDCDC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 21,
    height: 6,
    fill: "#CCCDCF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 12,
    height: 2,
    fill: "#949DA2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 21,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 27,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 31,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 33,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 37,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 38,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 41,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 43,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 47,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 48,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 51,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 53,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 9.5,
    width: 20,
    height: 52,
    fill: "#D9D9D9",
    stroke: "#DCDCDC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 9,
    width: 21,
    height: 6,
    fill: "#CCCDCF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 11,
    width: 12,
    height: 2,
    fill: "#949DA2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 21,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 33,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 37,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 38,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 41,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 43,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 48,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 51,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 53,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 9.5,
    width: 20,
    height: 52,
    fill: "#D9D9D9",
    stroke: "#DCDCDC"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 9,
    width: 21,
    height: 6,
    fill: "#CCCDCF"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 11,
    width: 12,
    height: 2,
    fill: "#949DA2"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 17,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 21,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 23,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 31,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 33,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 37,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 38,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 41,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 43,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 47,
    width: 19,
    height: 8,
    fill: "#CCCDCF"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 48,
    width: 10,
    height: 2,
    fill: "#A3A7A9"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 51,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 53,
    width: 7,
    height: 1,
    fill: "#9BAEB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 7.5H89.5V62C89.5 62.8284 88.8284 63.5 88 63.5H51.5V7.5Z",
    fill: "white",
    stroke: "#2B74DA"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 7,
    width: 39,
    height: 5,
    fill: "#2B74DA"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 14,
    width: 9,
    height: 2,
    fill: "#E3E5E9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 25,
    width: 9,
    height: 2,
    fill: "#E3E5E9"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 36,
    width: 9,
    height: 2,
    fill: "#E3E5E9"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 47,
    width: 9,
    height: 2,
    fill: "#E3E5E9"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 17,
    width: 22,
    height: 3,
    fill: "#CED1D3"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 22,
    height: 3,
    fill: "#CED1D3"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 39,
    width: 22,
    height: 3,
    fill: "#CED1D3"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 50,
    width: 22,
    height: 3,
    fill: "#CED1D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.caddf8411392607bb2e0e2a711faf70c.svg";
export { ForwardRef as ReactComponent };